import React, { useState, useEffect, useContext, useRef } from "react";
import { HistoryProduct as Product } from "../../../modals/Product";
import { HistoryProductService, RemoveHistoryProductService } from "../../../services/services";
import { generalMessages } from "../../../utils/constants";
import Loader from "../../Loader";
import HistoryProductDetail from "./historyProductDetail";
import HistoryProduct from "./historyProduct";
import AppContext from "../../../context/AppContext";
import SearchIcon from "../../../assets/images/Search_Icon.png";
import InfiniteScroll from 'react-infinite-scroll-component';
import { debounce } from 'lodash';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from "react-toastify";

const HistoryProducts = () => {
    const history = useHistory();
    const { id } = useParams<{ id?: string }>();

    const { tokenExpired } = useContext(AppContext);
    const [selectedProduct, setSelectedProduct] = useState<number | null>(null);
    const [status, setStatus] = useState<string | null>(null);
    const [filterproducts, setfilterProducts] = useState<Product[]>([]);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [page, setPage] = useState<number>(1);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [loading, setLoading] = useState(false);

    // Add this ref to store scroll position
    const scrollPositionRef = useRef(0);

    useEffect(() => {
        if (id) {
            // Save current scroll position before navigating to detail
            scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;

            setSelectedProduct(Number.parseInt(id));
        } else {
            setSelectedProduct(null);

            getUserHistoryProducts(page, searchTerm);

            // Restore scroll position after a brief delay to ensure DOM is updated
            setTimeout(() => {
                window.scrollTo({
                    top: scrollPositionRef.current,
                    behavior: 'auto' // Use 'auto' for instant scroll, 'smooth' for animated
                });
            }, 0);
        }
    }, [id]); // eslint-disable-line

    const getUserHistoryProducts = async (page: number, searchTerm: string = '') => {
        setStatus(null);
        setLoading(true);
        HistoryProductService(page, searchTerm)
            .then((result) => {
                if (result.data.data.length > 0) {
                    const newProducts = result.data.data;
                    if(page == 1){
                        setfilterProducts(newProducts);
                    } else {
                        setfilterProducts((prev) => [...prev, ...newProducts]);
                    }
                    setHasMore((page * 10) < result.data.total);
                } else {
                    setfilterProducts([]);
                    setHasMore(false);
                    if (result.data.data.length === 0) {
                        setStatus(generalMessages.EMPTY_PRODUCTS);
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    tokenExpired();
                }
                setStatus(generalMessages.ERROR_MSG);
            });
    };

    /////search features
    const handleSearch = useRef(
        debounce((value: string) => {
            setSearchTerm(value);
            setfilterProducts([]);
            setPage(1);
            setHasMore(true);
            getUserHistoryProducts(1, value);
        }, 400)).current;

    const onSearchInputChange = (value) => {
        setSearchTerm(value);
        if(value.length >= 3){
            handleSearch(value);
        } else if (value.length == 0) {
            handleSearch(value);
        }
    };

    const handleSelectedProduct = (productId: number) => {
        // Save scroll position before navigation
        scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop;

        setSelectedProduct(productId);
        history.push(`/product/history/${productId}`); // unique URL for product detail
    }

    const handleRemoveHistoryProduct = (productId: number) => {
        RemoveHistoryProductService(productId)
            .then((result) => {
                toast.success(result.data.message);
                setfilterProducts((prev) => prev.filter((p) => p.product_id !== productId));
            })
            .catch((err) => {
                const errorMsg = err.response?.data?.message || "Failed to remove product from history";
                console.error("Error removing product from history", err);
                toast.error(errorMsg);
            });
    };

    return (selectedProduct && id) ? (
        <HistoryProductDetail
            id={selectedProduct}
            backToList={() => {
                setSelectedProduct(null)
                history.push(`/product/history`);
            } }
        />
    ) : (
        <div className="product-wrapper container-xl">
            <div
                className="form-group"
                style={{
                    position: "relative",
                    width: "-webkit-fill-available",
                }}
            >
                <input
                    style={{
                        width: "-webkit-fill-available",
                        // background: "#f4f4f4",
                        marginBottom: "20px",
                    }}
                    value={searchTerm}
                    onChange={(e) => onSearchInputChange(e.target.value)}
                    placeholder={"Search History Product"}
                    className="form-control"
                />

                <img
                    src={SearchIcon}
                    alt=""
                    style={{
                        position: "absolute",
                        right: 18,
                        bottom: 10,
                        height: 30,
                    }}
                />
            </div>
            {/* Loop Start */}
            <section className="product-details">
                <div className="container-xl">
                    {loading && page == 1 ? <Loader /> : (
                        <InfiniteScroll 
                            dataLength={filterproducts.length} 
                            next={() => {
                                const nextPage = page + 1;
                                setPage(nextPage);
                                getUserHistoryProducts(nextPage, searchTerm);
                            }} 
                            hasMore={hasMore}
                            loader={loading ? <Loader /> : null}
                            style={{overflow: 'visible'}}
                        >
                        {/* history product loop */}
                        <div className="product-list-item-wrapper">
                            {status
                                ? status
                                : filterproducts.length !== 0
                                ? filterproducts.map((product) => (
                                    <HistoryProduct
                                        key={product.id}
                                        {...product}
                                        loadItem={() =>
                                            handleSelectedProduct(product.product_id)
                                        }
                                        removeProduct={() => handleRemoveHistoryProduct(product.product_id)}
                                    />
                                ))
                                : generalMessages.EMPTY_PRODUCTS}
                        </div>
                        </InfiniteScroll>
                    )}
                </div>
            </section>
        </div>
    );
};

export default HistoryProducts;
